// @flow
/*
  Take a function that expects varargs and turn it into a function that
  expects an array
*/
export const gather = (fn: Function) => (args: mixed) => fn.apply(this, args);

// Take the complement of a function
export const complement = <T>(f: T => boolean): (T => boolean) => (...args) =>
  !f(...args);

export const partial = (f: Function, ...args: Array<mixed>) => (
  ...otherArgs: Array<mixed>
) => f(...args, ...otherArgs);

export const compose = (...fargs: Array<Function>) => (
  ...initArgs: Array<mixed>
) =>
  fargs
    .slice(0, -1)
    .reduceRight((acc, f) => f(acc), fargs[fargs.length - 1](...initArgs));

// Takes a function f and returns another function that returns the
// values that f would return, but wrapped in a promise
export const wrapPromise = <T>(f: any => T) => (...args: any): Promise<T> =>
  Promise.resolve(f(...args));

export const identity = <T>(x: T): T => x;

export const defer = (fn: Function) => setTimeout(fn, 0);
